import { Language, selectLanguage } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { actions as resourceActions, ListResourcesResult } from '@ff-os/pdp-shared-redux/slices/resourcesSlice';
import { selectTenantId } from '@ff-os/pdp-shared-redux/slices/tenantSlice';
import { PdpStore } from '@ff-os/pdp-shared-redux/store';
import { urls } from '@ff-os/shared-utils/urls';
import fetch from 'cross-fetch';

export const preloadResources = async (store: PdpStore, languageOverride?: Language) => {

    const state = store.getState();
    const { scene } = state;
    const language = languageOverride ?? selectLanguage(state);
    const tenantId = selectTenantId(state);

    const resources = await loadResources(scene.id, 'prefab', tenantId);

    store.dispatch(resourceActions.replace({ ...resources, language }));
};

const loadResources = async (sceneId: string, type: string, tenantId: string): Promise<ListResourcesResult> => {

    const url = urls.listResources(sceneId, type, tenantId);

    const response = await fetch(url);
    if (response.status !== 200) {
        throw new Error(`[${response.status}] Failed to load resources for scene ID "${sceneId}" from "${url}"`);
    }

    const jsonResponse = await response.json();
    return { resourceType: type, entries: jsonResponse.entries };
};